/* this file added by Bearer Web Developer  */

import getNextSomeDays from "../../../../app/getNextSomeDays";
import getTime from "../../../../app/getTime";
import { compareDateEqual, compareDatePast, TimeSensitiveEnum } from "../../../../states/scheduleOrderstate";
import getDate from "./getDate";

const timeSensitiveManagement = (earliestTime: number): TimeSensitiveEnum => {
    const todayDate = getDate();
    const earliestDate = getDate(earliestTime);
    if (earliestDate === getNextSomeDays(1)) { // Earliest Date is Tomorrow
        return TimeSensitiveEnum.DueSoon;
    } else if (compareDatePast(earliestDate, todayDate)) {  // Earliest Date is Past
        return TimeSensitiveEnum.PastDue;
    } else if (compareDateEqual(earliestDate, todayDate)) { // Earliest Date is Today
        const [todayHour, todayMinute] = getTime().split(':').map(Number);
        const [earliestHour, earliestMinute] = getTime(earliestTime).split(':').map(Number);
        if (todayHour > earliestHour || (todayHour === earliestHour && todayMinute > earliestMinute)) return TimeSensitiveEnum.DueTodayPastTime;
        return TimeSensitiveEnum.DueToday;
    } else return TimeSensitiveEnum.TimeSensitive;
}
export default timeSensitiveManagement;